import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Accordion from "../shared/Accordion";

export default function FAQ({ faqs }) {
  const location = useLocation();

  return (
    <section className="my-20">
      {location.pathname === "/faq" ? (
        <Helmet>
          <title>Dailysocialboost | FAQ</title>
        </Helmet>
      ) : null}
      <h2 className="text-center text-4xl sm:text-5xl font-bold my-10">Frequently Asked Questions</h2>
      <div>
        {faqs?.map((question, idx) => (
          <Accordion
            key={idx}
            idx={idx + Math.random()}
            title={question.title}
            content={question.content}
          />
        ))}
      </div>
    </section>
  );
}
